import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from '../reducers';

const history = createBrowserHistory();

const store = createStore(
  createRootReducer(history), // root reducer with router state
  composeWithDevTools( // Activate Dev Tools
    applyMiddleware(
      routerMiddleware(history), // Middleware for dispatching router navigation
      thunkMiddleware,
    ),
  ),
);

export { history, store }
